
import { defineComponent } from 'vue';
import SvgIcon from './SvgIcon.vue';
import { VPopover } from 'v-tooltip';

export default defineComponent({
  name: 'BaseIconTooltip',
  components: {
    SvgIcon,
    VPopover
  },
  props: {
    trackingName: {
      type: String,
      default: ''
    },
    trackingDescription: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md',
      validator(value: string) {
        return ['sm', 'md', 'lg', 'xl', '2xl'].includes(value);
      }
    }
  }
});
